import axios from '@/utilities/axios-global'

export function GET_BLOG_FEED(context, offset) {
  offset = offset || 0
  return new Promise((resolve, reject) => {
    // use create here so that the bearer token doesn't get added
    axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/utilities/blogposts/${offset}`).then(response => {
      context.commit('SET_BLOG_FEED', response.data)
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export default {
  GET_BLOG_FEED
}
